'use client';
import { Option } from 'effect';

import { fetchArticlesPageAtom } from '@vs-shop/engine/atom/articles/fetchArticlesPage';
import type { AuthorId, CategoryId } from '@vs-shop/schemas/branded/ContentSchema';
import { pageSearchParamAtom } from '@vs-shop/engine/atom/products/pagination';
import type { ArticleIndex } from '../../../effect/schema/openapi/backend';
import type { HydraCollectionResponseType } from '@vs-shop/schemas/openapi/response';
import * as AsyncResult from 'effect/unstable/reactivity/AsyncResult';
import { useAtomInitialValues } from '@effect/atom-react';

type Props = {
  page: number;
  itemsPerPage: number;
  section: string | undefined;
  categoryId: CategoryId | undefined;
  authorId: AuthorId | undefined;
  articlesResponse: HydraCollectionResponseType<typeof ArticleIndex>;
};

export default function ArticlesContextInitializer({
  page,
  itemsPerPage,
  section,
  categoryId,
  authorId,
  articlesResponse,
}: Props) {
  useAtomInitialValues([
    [
      fetchArticlesPageAtom(page, itemsPerPage, section, categoryId, authorId),
      AsyncResult.success(articlesResponse),
    ],
    [pageSearchParamAtom, Option.some(page)],
  ]);

  return null;
}
